/* woolberry: product size helpers
   1) Default the size selector to S whenever someone lands on a product page
      (unless a specific ?variant is deep-linked, so shared variant links still
      resolve to what they point at).
   2) Show the shopper's own size numbering next to "Size: <letter>" and keep it
      in sync as they switch sizes. The server renders the right value on first
      paint (see snippets/product-variant-picker.liquid); this is the mirror for
      changes made without a reload.

   The market -> system mapping below is the SAME one in
   snippets/wb-size-label.liquid (server) and defaultSystem() in
   assets/wb-sizechart.js (the size chart's default). All three must agree, or
   the label will contradict the chart the shopper opens from it:
     UK  GB, IE   Ireland prices in EUR but shops in UK dress sizes.
     AU  AU       Australian numbering matches the UK's, so it shares the UK
                  scale and only the prefix differs.
     US  US, CA   Canada uses the US system outright.
     EU  the rest 34/36/38/40 across Germany, Austria, France, the Netherlands,
                  Spain, Poland, Sweden, Denmark and Switzerland.
   France sits in EU on purpose: French sizing runs two above the EU number,
   but the chart has no FR column, so an FR label would contradict it.
   Anything unmapped falls back to UK, the store's home market. */
(function () {
  var SCALES = {
    UK: { XXS: '4',  XS: '6',  S: '8',  M: '10', L: '12', XL: '14', XXL: '16' },
    US: { XXS: '0',  XS: '2',  S: '4',  M: '6',  L: '8',  XL: '10', XXL: '12' },
    EU: { XXS: '32', XS: '34', S: '36', M: '38', L: '40', XL: '42', XXL: '44' }
  };

  var EU_COUNTRIES = ['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE',
                      'GR','HU','IT','LV','LT','LU','MT','NL','PL','PT','RO',
                      'SK','SI','ES','SE','IS','LI','NO','CH'];

  /* -> { prefix: 'UK', scale: SCALES.UK } for the active market. */
  function system() {
    var c = (window.Shopify && Shopify.country ? String(Shopify.country) : '').toUpperCase();
    if (c === 'AU') return { prefix: 'AU', scale: SCALES.UK };
    if (c === 'US' || c === 'CA') return { prefix: 'US', scale: SCALES.US };
    if (c === 'GB' || c === 'IE') return { prefix: 'UK', scale: SCALES.UK };
    if (EU_COUNTRIES.indexOf(c) !== -1) return { prefix: 'EU', scale: SCALES.EU };
    return { prefix: 'UK', scale: SCALES.UK };
  }

  function sizeFieldset() {
    var legends = document.querySelectorAll('.radio__legend');
    for (var i = 0; i < legends.length; i++) {
      var name = legends[i].querySelector('.radio__legend__option-name');
      var label = name || legends[i].querySelector('.radio__legend__label');
      var text = label ? label.textContent.trim().toLowerCase() : '';
      if (text === 'size' || text.indexOf('size') === 0) {
        return legends[i].closest('fieldset');
      }
    }
    return null;
  }

  function checkedValue(fs) {
    var c = fs.querySelector('input[type="radio"]:checked');
    return c ? c.value : null;
  }

  function updateUK() {
    var fs = sizeFieldset();
    if (!fs) return;
    var v = checkedValue(fs);
    var sys = system();
    var num = v ? sys.scale[v.toUpperCase()] : '';

    // the "Size: S (UK 8)" / "Size: S (US 4)" label on the PDP
    var el = fs.querySelector('[data-wb-uk]');
    if (el) el.textContent = num ? '(' + sys.prefix + ' ' + num + ')' : '';

    // the checkout line-item property (kept in sync with the selected size).
    // Only the value moves — the property NAME is server-rendered per market
    // and can't change without a reload, which is also when the market changes.
    var props = document.querySelectorAll('[data-wb-uk-prop]');
    for (var i = 0; i < props.length; i++) {
      props[i].value = num || '';
      props[i].disabled = !num;
    }
  }

  function defaultToS() {
    if (location.search.indexOf('variant=') !== -1) return; // respect deep-links
    var fs = sizeFieldset();
    if (!fs) return;
    if ((checkedValue(fs) || '').toUpperCase() === 'S') return; // already S
    var inputs = fs.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value.toUpperCase() === 'S') {
        // click fires the native change the theme listens to (updates the
        // variant, price, URL and the "Size: S" label in one go)
        inputs[i].click();
        return;
      }
    }
  }

  function init() {
    defaultToS();
    updateUK();

    var fs = sizeFieldset();
    if (fs) fs.addEventListener('change', updateUK);

    // the theme may rewrite the selected-value text on variant change without a
    // full re-render — mirror that onto the UK label.
    var sel = document.querySelector('.radio__legend [data-selected-value]');
    if (sel) {
      new MutationObserver(updateUK).observe(sel, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
